import { startOfLocalDay, endOfLocalDay } from '../../service/dates';

// Filas del «Reporte de ventas por producto» (H28). El backend manda `total` y `sold` como
// texto (Decimal serializado): `total.toFixed(2)` fallaba y la columna «Total Vendido» quedaba
// en blanco, y ordenar comparaba textos («9» > «10»). Se normalizan a número al cargar.
export function normalizeProductSalesReport(data) {
    const rows = Array.isArray(data) ? data : Object.values(data || {});
    return rows.map((row) => {
        const sold = Number(row.sold) || 0;
        const total = Number(row.total) || 0;
        return { ...row, sold, total, averagePrice: sold ? total / sold : 0 };
    });
}

// Rango del reporte: los bordes del día local como instantes ISO, igual que el Kardex (H64).
// Los calendarios llevaban hora y, al elegir solo el día, conservaban la hora actual: el
// reporte de «hoy a hoy» salía vacío. La fecha final incluye su día completo; sin fecha, ese
// lado del rango queda abierto.
export function reportRange(startDate, endDate) {
    const start = startOfLocalDay(startDate);
    const end = endOfLocalDay(endDate);
    return {
        initialDate: start ? start.toISOString() : null,
        finalDate: end ? end.toISOString() : null,
    };
}
